import React, { useEffect, useState } from "react";
import "./Sales.css";

// components imports
import CarrierTableLoader from "../../Components/CarrierInnerTableLoader/CarrierInnerTableLoader";
import Attachments from "./Components/Attachment";
import OrderHistoryModal from "../Shipper/Customer/MainPages/Orders/Components/OrderHistoryModal/OrderHistoryModal";
import CircularLoader from "../../Components/CircularLoader/CircularLoader";
import { showSnackBar } from "../../store/common/snackBarSlice";
import PickupAddress from "./Components/PicupAddress";
import DeliveryAddress from "./Components/DeliveryAddress";
import AvailableProducts from "./Components/AvailableProducts";
import PaymentDetails from "./Components/PaymentDetails";
import ShipmentDetails from "./Components/ShipmentDetails";
import Products from "./Components/SelectedProducts";
import ShopifyProductList from "./Components/shopifyProducts";
// apis imports
import {
  storeOrder,
  updateOrder,
  fetchSingleOrder,
} from "../../services/orders.services";
// library imports

import { BiArrowBack } from "react-icons/bi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";

const initialData = {
  order_id: "",
  order_type: "",
  type: "Manual",
  status: "Confirmed",
  currency: "CAD",
  customer_note: "",
  payment_method_title: "Direct Bank Transfer",
  discount_total: 0,
  discount_tax: 0,
  amount_received: "",
  amount_pending: "",
  order_status_id: "2",
  fulfillment_payment_status: "unpaid",
  formula: "",
  shipping_total: 0,
  shipping_tax: 0,
  total: 0,
  total_tax: 0,
  items: [],
  attachments: [],
  billing: {
    first_name: "",
    last_name: "",
    company: "",
    address_1: "",
    address_2: "",
    city: "",
    state: "",
    postcode: "",
    country: "",
    email: "",
    phone: "",
  },
  shipping: {
    first_name: "",
    last_name: "",
    company: "",
    address_1: "",
    address_2: "",
    city: "",
    state: "",
    postcode: "",
    country: "",
    phone: "",
  },
  warehouse: {
    full_address: "",
    country: "",
    country_name: "",
    state_provience: "",
    state_name: "",
    city_town: "",
    zip_postal: "",
    company: "",
    attention: "",
    phone: "",
    email: "",
  },
  OrderShipment: {
    shipment_status: "",
    shipment_tracking_id: "",
    pickup_id: "",
    pickup_date: "",
    shipping_company: null,
    prev_labels: [],
    prev_declaration: [],
    labels: [],
    declaration: [],
  },
};

const Sales = () => {
  const { t } = useTranslation("sales");
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(initialData);
  const [creatingOrder, setCreatingOrder] = useState(false);
  const [SelectedProducts, setSelectedProducts] = useState([]);
  const [ShopifyProducts, setShopifyProducts] = useState([]);
  const [Warehouse, setWarehouse] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [duplicateMode, setDuplicateMode] = useState(false);
  const [notesHistoryModal, setNotesHistoryModal] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [formula, Setformula] = useState({
    TotalFulfilmentCost: 0,
    TotalWeightCost: 0,
    TotalPreCost: 0,
    TotalFulfilmentWeight: 0,
    TotalPreProduct: 0,
    UnitType: "",
  });

  const handleCreateOrder = async () => {
    let salePrice = 0;
    const itemsArray = SelectedProducts.map((product, index) => {
      // Extract relevant information from each product
      salePrice += parseFloat(product.sale_price) * product.quantity;
      const item = {
        item_id: product.id,
        productLotData: product?.productLotData ?? null,
        active_price: product.sale_price,
        regular_price: product.regular_price,
        sale_price: product.sale_price,
        sku: product.code,
        fulfillment_cost: product.fulfillment_cost,
        product_name: product.full_name,
        item_quantity: product.quantity,
        length: product.length,
        width: product.width,
        height: product.height,
        weight: product.weight,
        product_length_type: "Imperial",
        bolt_package_detail: product.package_details,
        item_subtotal: product.sale_price,
        item_subto_tax: 0,
        item_total: product.sale_price,
        item_total_tax: 0,
        item_tax_status: "taxable",
        note: product.note ?? "",
      };

      return item;
    });

    let payload = {
      ...data,
      total: salePrice,
      items: itemsArray,
      warehouse_id: Warehouse,
      formula: formula,
      fulfillment_cost: formula.TotalFulfilmentCost,
    };
    setCreatingOrder(true);
    const { note, attachments, ...payloadData } = payload;
    const formData = new FormData();
    if (attachments?.length > 0 || note) {
      formData.append(
        "orderNotes",
        JSON.stringify({ note: note, type: "global" })
      );

      if (attachments?.length > 0) {
        attachments.forEach((attachment, index) => {
          formData.append(`orderAttachments[${index}]`, attachment);
        });
      }
    }

    if (payload?.OrderShipment?.shipping_company) {
      let idx = 0;
      let shipment_data = {
        shipment_status: payload?.OrderShipment?.shipment_status,
        shipment_tracking_id: payload?.OrderShipment?.shipment_tracking_id,
        pickup_id: payload?.OrderShipment?.pickup_id,
        pickup_date: payload?.OrderShipment?.pickup_date,
        user_shipping_company_id:
          payload?.OrderShipment?.shipping_company?.type === "default"
            ? payload?.OrderShipment?.shipping_company?.id
            : null,
        manual_user_shipping_company_id:
          payload?.OrderShipment?.shipping_company?.type === "manual"
            ? payload?.OrderShipment?.shipping_company?.id
            : null,
      };
      if (payload?.OrderShipment?.labels?.length > 0) {
        payload?.OrderShipment?.labels.forEach((attachment, index) => {
          formData.append(`shipment_media[${idx}][file]`, attachment);
          formData.append(`shipment_media[${idx}][type]`, "label");
          formData.append(
            `shipment_media[${idx}][carrier]`,
            payload?.OrderShipment?.shipping_company?.name ?? ""
          );
          formData.append(
            `shipment_media[${idx}][tracking_id]`,
            payload?.OrderShipment?.shipment_tracking_id ?? ""
          );
          idx++;
        });
      }
      if (payload?.OrderShipment?.declaration?.length > 0) {
        payload?.OrderShipment?.declaration.forEach((attachment, index) => {
          formData.append(`shipment_media[${idx}][file]`, attachment);
          formData.append(`shipment_media[${idx}][type]`, "declaration");
          formData.append(`shipment_media[${idx}][carrier]`, "label");
          formData.append(
            `shipment_media[${idx}][carrier]`,
            payload?.OrderShipment?.shipping_company?.name ?? ""
          );
          formData.append(
            `shipment_media[${idx}][tracking_id]`,
            payload?.OrderShipment?.shipment_tracking_id ?? ""
          );
          idx++;
        });
      }
      formData.append("shipment_data", JSON.stringify(shipment_data));
    }

    formData.append("order", JSON.stringify(payloadData));

    try {
      const response = await storeOrder(formData);
      if (response.error) {
        setCreatingOrder(false);
        dispatch(
          showSnackBar({
            text:
              response?.error?.response?.data?.message ??
              t("somethingWentWrong"),
            severity: "error",
          })
        );
      } else {
        setData(initialData);
        setCreatingOrder(false);
        dispatch(
          showSnackBar({
            text: response?.data?.message,
            severity: "success",
          })
        );
        navigate("/orders");
      }
    } catch (error) {
      setCreatingOrder(false);
      console.log("error", error);
      dispatch(
        showSnackBar({
          text: t("somethingWentWrong"),
          severity: "error",
        })
      );
    }
  };
  const handleUpdateOrder = async () => {
    setCreatingOrder(false);
    // console.log(data?.warehouse);
    let salePrice = 0;
    const itemsArray = SelectedProducts.map((product, index) => {
      // Extract relevant information from each product
      salePrice += parseFloat(product.sale_price) * product.quantity;
      const additionalField = product.order_id ? { id: product.order_id } : {};
      const item = {
        ...additionalField,
        item_id: product.id,
        productLotData: product?.productLotData ?? null,
        deletedLotDataIds: product?.deletedLotDataIds ?? [],
        active_price: product.sale_price,
        regular_price: product.regular_price,
        sale_price: product.sale_price,
        sku: product.code,
        fulfillment_cost: product.fulfillment_cost,
        product_name: product.full_name,
        item_quantity: product.quantity,
        length: product.length,
        width: product.width,
        height: product.height,
        weight: product.weight,
        product_length_type: "Imperial",
        bolt_package_detail: product.package_details,
        item_subtotal: product.sale_price,
        item_subto_tax: 0,
        item_total: product.sale_price,
        item_total_tax: 0,
        item_tax_status: "taxable",
        note: product.note ?? "",
      };

      return item;
    });

    let payload = {
      ...data,
      total: salePrice,
      items: itemsArray,
      warehouse_id: Warehouse,
      formula: formula,
      fulfillment_cost: formula.TotalFulfilmentCost,
    };

    if (
      !payload?.OrderShipment?.shipping_company &&
      payload?.manual_shipment_id
    ) {
      dispatch(
        showSnackBar({
          text: t("shippingCompanyMustBeSelected"),
          severity: "error",
        })
      );
      return;
    }

    setCreatingOrder(true);
    try {
      const { note, attachments, ...payloadData } = payload;
      let shipment_data = {
        shipment_status: payload?.OrderShipment?.shipment_status,
        shipment_tracking_id: payload?.OrderShipment?.shipment_tracking_id,
        pickup_id: payload?.OrderShipment?.pickup_id,
        pickup_date: payload?.OrderShipment?.pickup_date,
        user_shipping_company_id:
          payload?.OrderShipment?.shipping_company?.type === "default"
            ? payload?.OrderShipment?.shipping_company?.id
            : null,
        manual_user_shipping_company_id:
          payload?.OrderShipment?.shipping_company?.type === "manual"
            ? payload?.OrderShipment?.shipping_company?.id
            : null,
      };
      const formData = new FormData();
      if (attachments?.length > 0 || note) {
        formData.append(
          "orderNotes",
          JSON.stringify({ note: note, type: "global" })
        );

        if (attachments?.length > 0) {
          attachments.forEach((attachment, index) => {
            formData.append(`orderAttachments[${index}]`, attachment);
          });
        }
      }
      if (!payload?.shipment_id && payload?.OrderShipment?.shipping_company) {
        let idx = 0;
        if (payload?.OrderShipment?.labels?.length > 0) {
          payload?.OrderShipment?.labels.forEach((attachment, index) => {
            formData.append(`shipment_media[${idx}][file]`, attachment);
            formData.append(`shipment_media[${idx}][type]`, "label");
            formData.append(
              `shipment_media[${idx}][carrier]`,
              payload?.OrderShipment?.shipping_company?.name ?? ""
            );
            formData.append(
              `shipment_media[${idx}][tracking_id]`,
              payload?.OrderShipment?.shipment_tracking_id ?? ""
            );
            idx++;
          });
        }
        if (payload?.OrderShipment?.declaration?.length > 0) {
          payload?.OrderShipment?.declaration.forEach((attachment, index) => {
            formData.append(`shipment_media[${idx}][file]`, attachment);
            formData.append(`shipment_media[${idx}][type]`, "declaration");
            formData.append(`shipment_media[${idx}][carrier]`, "label");
            formData.append(
              `shipment_media[${idx}][carrier]`,
              payload?.OrderShipment?.shipping_company?.name ?? ""
            );
            formData.append(
              `shipment_media[${idx}][tracking_id]`,
              payload?.OrderShipment?.shipment_tracking_id ?? ""
            );
            idx++;
          });
        }
        formData.append(
          "deleted_shipment_media_id",
          JSON.stringify(payload?.OrderShipment?.deleted_shipment_media_id)
        );
        formData.append("shipment_data", JSON.stringify(shipment_data));
      }

      delete payloadData.OrderShipment;
      delete payloadData.fullfilment_status;
      delete payloadData.shipment;
      delete payloadData.manual_shipment;
      delete payloadData.fullfullment_billing_status_history;
      delete payloadData.order_market_place_details;

      formData.append("order", JSON.stringify(payloadData));

      const response = await updateOrder(formData, data?.id);

      if (response.error) {
        setCreatingOrder(false);
        dispatch(
          showSnackBar({
            text:
              response?.error?.response?.data?.message ??
              t("somethingWentWrong"),
            severity: "error",
          })
        );
      } else {
        dispatch(
          showSnackBar({
            text: response?.data?.message,
            severity: "success",
          })
        );
        setCreatingOrder(false);
        navigate("/orders");
      }
    } catch (error) {
      setCreatingOrder(false);
      console.log("error", error);
      dispatch(
        showSnackBar({
          text: error?.message || t("somethingWentWrong"),
          severity: "error",
        })
      );
    }
  };

  const getOrder = useCallback(
    async (id) => {
      try {
        const response = await fetchSingleOrder(id);
        if (response.error) {
          dispatch(
            showSnackBar({
              text: i18n.t("common:messages.somethingWentWrong"),
              severity: "error",
            })
          );
          return;
        }

        const {
          order_details,
          order_billing_address_details,
          order_pickup_details,
          order_shipping_address_details,
          warehouse_id,
          created_at,
          updated_at,
          order_notes,
          ...restResult // excludes the above keys
        } = response?.data?.result;

        setEditMode(location.state?.editMode);
        setDuplicateMode(location.state?.duplicateMode);

        const excludeFields = ({ created_at, updated_at, ...rest }) => rest;

        // Extract address details
        const warehouse = excludeFields(
          order_pickup_details[0] ?? order_pickup_details
        );
        const billing = excludeFields(
          order_billing_address_details[0] ?? order_billing_address_details
        );
        const shipping = excludeFields(
          order_shipping_address_details[0] ?? order_shipping_address_details
        );

        // Build OrderShipment object
        const OrderShipment = buildOrderShipment(response?.data?.result);

        // Prepare base order data
        let orderData = {
          ...restResult, // does NOT include removed keys
          order_status_id:
            response?.data?.result?.fullfilment_status?.name?.toLowerCase() ===
            "attention"
              ? 5
              : response?.data?.result?.order_status_id,
          deletedItemIds: [],
          attachments: [],
          warehouse,
          billing,
          shipping,
          OrderShipment,
        };

        // Apply duplicate mode logic if enabled
        if (location.state?.duplicateMode) {
          orderData = resetForDuplicate(orderData);
        }

        setData(orderData);

        // Prepare selected products
        const orderDetails = order_details?.map((orderDetail) =>
          excludeFields(orderDetail)
        );

        const selectedProductsArray = [];
        const shopifyProductsArray = [];

        orderDetails?.forEach((item) => {
          if (item?.plugin_item_id) {
            shopifyProductsArray.push(item);
          } else {
            selectedProductsArray.push(
              mapProductData(item, location.state?.duplicateMode)
            );
          }
        });

        setSelectedProducts(selectedProductsArray);
        setShopifyProducts(shopifyProductsArray);

        setWarehouse(warehouse_id);
      } catch (error) {
        console.error("Error fetching order:", error);
        dispatch(
          showSnackBar({
            text: i18n.t("sales:failedToFetchOrder"),
            severity: "error",
          })
        );
      } finally {
        setLoading(false);
      }
    },
    [location.state]
  );

  /** ---------- Helper Functions ---------- **/

  // Build OrderShipment object based on response
  const buildOrderShipment = (result) => {
    if (result?.manual_shipment) {
      const manual = result.manual_shipment;
      const shippingCompany = manual.manual_shipping_company
        ? {
            id: manual.manual_shipping_company.id,
            type: "manual",
            name: manual.manual_shipping_company.shipping_company_name,
          }
        : manual.shipping_company?.shipping_company
        ? {
            id: manual.shipping_company.id,
            type: "default",
            name: manual.shipping_company.shipping_company.name,
          }
        : null;

      return {
        shipment_status: manual.shipment_status,
        shipment_tracking_id: manual.shipment_tracking_id,
        pickup_id: manual.pickup_id,
        pickup_date: manual.pickup_date,
        shipping_company: shippingCompany,
        prev_labels: manual.shipping_labels ?? [],
        prev_declaration: manual.shipping_declarations ?? [],
        labels: [],
        declaration: [],
        deleted_shipment_media_id: [],
      };
    }

    if (result?.shipment) {
      const shipment = result.shipment;
      return {
        shipment_status: shipment.shipment_status,
        shipment_tracking_id: shipment.shipment_tracking_id,
        pickup_id: shipment.PickupID,
        pickup_date: shipment.PickupDate,
        shipping_company: {
          id: shipment.shipping_company?.id,
          type: "default",
          name: shipment.shipping_company?.shipping_company?.name,
        },
        prev_labels: shipment.single_shipping_labels
          ? [shipment.single_shipping_labels]
          : [],
        prev_declaration: shipment.single_shipping_invoice
          ? [shipment.single_shipping_invoice]
          : [],
        labels: [],
        declaration: [],
        deleted_shipment_media_id: [],
      };
    }

    // Default empty shipment
    return {
      shipment_status: "",
      shipment_tracking_id: "",
      pickup_id: "",
      pickup_date: "",
      shipping_company: null,
      prev_labels: [],
      prev_declaration: [],
      labels: [],
      declaration: [],
      deleted_shipment_media_id: [],
    };
  };

  // Reset fields for duplicate mode
  const resetForDuplicate = (data) => {
    const {
      id,
      user_id,
      customer_id,
      date_created,
      shippingAddress,
      order_response,
      billing_address,
      is_read,
      order_market_place_details,
      fullfilment_status,
      manual_shipment,
      shipment,
      fullfullment_billing_status_history,
      deletedItemIds,
      shopify_details,
      market_place_id,
      selected_shipping_detail,
      shipment_id,
      subtotal,
      amount_received_by_warehouse,
      deleted_at,
      market_place_status,
      fulfillment_billing_status,
      shipment_type,
      manual_shipment_id,
      additional_costs,
      ...rest
    } = data;
    return {
      ...rest,
      order_id: "",
      order_status_id: "2", // Default status for new order
      type: "Manual",
      status: "Confirmed",
      currency: "CAD",
      payment_method_title: "Direct Bank Transfer",
      fulfillment_payment_status: "unpaid",
      order_type: "",
      customer_note: "",
      amount_received: "",
      amount_pending: "",
      shipping_total: 0,
      shipping_tax: 0,
      total: 0,
      total_tax: 0,
      discount_total: 0,
      discount_tax: 0,
      fulfillment_cost: 0,
      OrderShipment: {
        shipment_status: "",
        shipment_tracking_id: "",
        pickup_id: "",
        pickup_date: "",
        shipping_company: null,
        prev_labels: [],
        prev_declaration: [],
        labels: [],
        declaration: [],
      },
      warehouse: data.warehouse
        ? (() => {
            const { id, order_id, ...warehouseRest } = data.warehouse;
            return { ...warehouseRest };
          })()
        : null,
      billing: data.billing
        ? (() => {
            const { id, order_id, ...billingRest } = data.billing;
            return { ...billingRest };
          })()
        : null,
      shipping: data.shipping
        ? (() => {
            const { id, order_id, ...shippingRest } = data.shipping;
            return { ...shippingRest };
          })()
        : null,
    };
  };

  // Map product data and handle duplicate mode
  const mapProductData = (orderDetail, isDuplicate) => {
    const lots = orderDetail?.order_item_product_lot_quantities?.map((lot) => ({
      product_lot_id: parseInt(lot?.product_lot_id),
      quantity: parseInt(lot?.quantity),
      name: lot?.product_lot?.name,
      id: isDuplicate ? undefined : lot?.id,
    }));

    return {
      ...orderDetail?.products,
      order_id: isDuplicate ? undefined : orderDetail?.id,
      productLotData: lots ?? [],
      fulfillment_cost: orderDetail?.fulfillment_cost,
      quantity: parseInt(orderDetail?.item_quantity),
      length: orderDetail?.length,
      width: orderDetail?.width,
      height: orderDetail?.height,
      weight: orderDetail?.weight,
      note: orderDetail?.note ?? "",
    };
  };

  useEffect(() => {
    if (
      location.state?.editMode === true ||
      location.state?.duplicateMode === true
    ) {
      const orderId = location.state?.orderId;
      if (orderId) {
        getOrder(orderId);
      }
    } else {
      setLoading(false);
    }
  }, [location, getOrder]);

  return (
    <div className="sales__section_screen">
      <OrderHistoryModal
        open={notesHistoryModal}
        setOpen={setNotesHistoryModal}
      />

      {!loading ? (
        <>
          <div className="saless__page_header_sec">
            <div className="add__prod_sheader hide_mobile_btn">
              <Link to={"/orders"}>
                <BiArrowBack size={22} className="add__prod_sheaderback" />
              </Link>
              {t("orders")}
            </div>
          </div>
          <div className="saless__address_section">
            {(editMode || duplicateMode) && (
              <div className="saless__address_sectionleft">
                <PickupAddress data={data} setData={setData} />
              </div>
            )}
            <div className="saless__address_sectionright">
              <DeliveryAddress
                data={data}
                setData={setData}
                editMode={editMode && !duplicateMode}
              />
            </div>
          </div>
          {editMode && ShopifyProducts?.length ? (
            <div className="saless__products_section">
              <div className="saless__products_sectionright">
                <ShopifyProductList ShopifyProducts={ShopifyProducts} />
              </div>
            </div>
          ) : null}
          <div className="saless__products_section">
            <div className="saless__products_sectionleft">
              <AvailableProducts
                data={data}
                setData={setData}
                SelectedProducts={SelectedProducts}
                setSelectedProducts={setSelectedProducts}
                Warehouse={Warehouse}
                setWarehouse={setWarehouse}
                editMode={editMode && !duplicateMode}
                disableAutoResizing={true}
              />
            </div>
          </div>
          <div className="saless__products_section">
            <div className="saless__products_sectionright">
              <Products
                data={data}
                setData={setData}
                SelectedProducts={SelectedProducts}
                setSelectedProducts={setSelectedProducts}
                Warehouse={Warehouse}
                setWarehouse={setWarehouse}
                Setformula={Setformula}
                formula={formula}
                editMode={editMode && !duplicateMode}
              />
            </div>
          </div>
          <div className="saless__address_section">
            <div className="saless__address_sectionleft">
              <PaymentDetails
                data={data}
                setData={setData}
                editMode={editMode && !duplicateMode}
                setEditMode={setEditMode}
              />
            </div>
            <div className="saless__address_sectionright">
              <ShipmentDetails
                data={data}
                setData={setData}
                editMode={editMode && !duplicateMode}
                setEditMode={setEditMode}
              />
            </div>
          </div>
          <Attachments
            data={data}
            setData={setData}
            notesHistoryModal={notesHistoryModal}
            setNotesHistoryModal={setNotesHistoryModal}
            editMode={editMode && !duplicateMode}
          />
          <div className="saless__bottomcreatebtn_wrap">
            <button
              className="saless__bottomcreate_btn"
              onClick={
                editMode && !duplicateMode
                  ? handleUpdateOrder
                  : handleCreateOrder
              }
              disabled={creatingOrder}
            >
              {creatingOrder ? (
                <CircularLoader />
              ) : (
                editMode && !duplicateMode
                  ? t("updateOrder")
                  : duplicateMode
                  ? t("duplicateOrder")
                  : t("createOrder")
              )}
            </button>
          </div>
        </>
      ) : (
        <div className="saless__order_loader">
          <CarrierTableLoader />
        </div>
      )}
    </div>
  );
};

export default Sales;
